module.exports = __webpack_public_path__ + "static/media/9.0f471e1e.jpg";